import { CustomField } from "../graphql/generated";

/**
 * Helper function to find a custom field value by key from an array of custom fields
 * @param customFields - Array of custom fields, may be null or undefined
 * @param key - The key of the custom field to find
 * @returns The value of the custom field if found, undefined otherwise
 */
export function getCustomFieldValue(
  customFields: CustomField[] | null | undefined,
  key: string
): any | undefined {
  if (!customFields || !Array.isArray(customFields)) {
    return undefined;
  }
  const field = customFields.find((cf) => cf.key === key);
  return field?.value;
}
